export default __webpack_public_path__ + "5990bac9ac676410a09b7f63527acb86.svg";